import {ProductEyeCatcher} from "./ProductEyeCatcher";
import { useTranslation } from "react-i18next";

interface ProductImageProps {
  src: string;
  alt: string;
  isPromoted: boolean;
  eyecatcher: string;
  onError: () => void;
  productLink: string;
}

export default function ProductImage({
  src,
  alt,
  isPromoted,
  eyecatcher,
  onError,
  productLink,
}: ProductImageProps): JSX.Element {
  const srcSet = src.includes("200x200")
    ? `${src} 1x, ${src.replace("200x200", "200x200x2")} 2x`
    : undefined;
  const { t } = useTranslation();

  return (
    <div className="product-card__image d-flex justify-content-center align-items-center">
      <a href={productLink} aria-label={`${alt} öffnen`}>
        <img
          src={src}
          loading="lazy"
          srcSet={srcSet}
          width="200"
          height="200"
          alt={alt}
          onError={onError}
        />
        {isPromoted && (
          <div className="adspirit__search-text-container">
            <p className="adspirit__search-text adspirit__search-text--block" aria-hidden="true">{(t('search.hits.productCard.advertisement') as string).toUpperCase()}</p>
            <span className="sr-only">{t('search.hits.productCard.advertisement') as string}</span>
          </div>
        )}
        <ProductEyeCatcher eyecatcher={eyecatcher} />
      </a>
    </div>
  );
}
